import { div, a, span, button, goTo } from '@srfnstack/fntags'
import { notification } from '../state.js'

export const ToastProvider = () => notification.bindAs(n => {
  if (!n.show) return div({ class: 'hidden' })

  let alertClass = 'alert-info'
  if (n.type === 'success') alertClass = 'alert-success'
  if (n.type === 'warning') alertClass = 'alert-warning'
  if (n.type === 'error') alertClass = 'alert-error'

  return div({ class: `toast ${n.position || 'toast-top toast-end'} z-[9999]` },
    div({ class: `alert ${alertClass} shadow-lg flex items-center justify-between min-w-[300px]` },
      div({ class: 'flex flex-col gap-1' },
        span(n.message),
        n.link
          ? a({
            href: n.link.href,
            class: 'link link-hover text-sm font-bold underline',
            onclick: (e) => {
              e.preventDefault()
              goTo(n.link.href)
              notification.assign({ show: false })
            }
          }, n.link.text)
          : null
      ),
      button({
        class: 'btn btn-ghost btn-xs',
        onclick: () => notification.assign({ show: false })
      }, '✕')
    )
  )
})
